function isHttpNotFound(error) {
  if (!error) {
    return false;
  }

  return error?.response?.status === 404 || error?.status === 404;
}

export function isStockPageNotFound({
  stockLoading,
  stockError,
  stockDataErrorResponse
} = {}) {
  return (
    (!stockLoading && isHttpNotFound(stockError)) ||
    isHttpNotFound(stockDataErrorResponse)
  );
}
